import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PersonList from "./PersonList";
import ParticipantExcelExport from "./ParticipantExcelExport";

const MainTabs = ({
  eventDetails,
  data,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  columns,
}) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Tabs value={value} onChange={handleChange} aria-label="event details">
          <Tab label="Details" />
        </Tabs>
        <ParticipantExcelExport data={data} eventName={eventDetails?.title} />
      </Box>
      <Box sx={{ p: 2 }}>
        {value === 0 && (
          <PersonList
            data={data}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            columns={columns}
          />
        )}
      </Box>
    </Box>
  );
};

export default MainTabs;
